import api from '@/apis/di/fixedAssetAPI.js';
import Crud from '@/stores/crudBase';
import { ModuleFixedAssetCache } from '@/stores/moduleConst';
var crud = new Crud('fixedAsset', api);
import store from '@/stores/store';

const state = {
  ...crud.state,
  _config: {
    table: 'di_fixed_asset',
    field: {
      key: 'fixed_asset_id',
      code: 'fixed_asset_code',
      name: 'fixed_asset_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * update lại trạng thái ghi tăng, ghi giảm, điều chỉnh tài sản cố định
   * @param {*} context
   * @param {*} postedDate
   * @param {*} items
   */
  async updateStausIncrement(context, postedDate, items) {
    let fixedAssetCodes = items || context.state.items;
    if (Array.isArray(fixedAssetCodes) && fixedAssetCodes.length > 0) {
      let payload = {
        FixedAssetCodes: fixedAssetCodes.map(x => x.fixed_asset_code),
        PostedDate: postedDate,
      };
      let result = await api.getStatusIncrementFixedAsseet(payload);
      context.commit('updateStausIncrement', result);
    }
  },

  /**
   * Load danh sách tài sản form tham sổ sổ ghi giảm TSCĐ
   * TPNAM 19.01.2023
   */
  async loadIncrementFixedAsset(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.loadIncrementFixedAsset(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      context.commit('setPaging', res);
    }

    return res;
  },

  /**
   * Load danh sách tài sản form tham sổ sổ ghi tăng TSCĐ
   * dqdat1 06.04.2023
   * **/
   async loadIncrementBookFixedAsset(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.loadIncrementBookFixedAsset(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      context.commit('setPaging', res);
    }

    return res;
  },
  /**
   * Load tổng số bản ghi tài sản form tham sổ sổ ghi giảm TSCĐ
   * TPNAM 19.01.2023
   */
  async loadSummaryIncrementFixedAsset(context, payload) {
    let res = null;
    try {
      context.commit('updateLoadingSummary', true);
      res = await api.loadIncrementFixedAsset(payload || {});
    } finally {
      context.commit('updateLoadingSummary', false);
    }

    if (res) {
      context.commit('setPaging', res);
      context.commit('setPayload', payload);
    }

    return res;
  },
  
  /**
   * Load tổng số bản ghi tài sản form tham sổ sổ ghi tăng TSCĐ
   * dqdat1 06.04.2023
   */
   async loadSummaryIncrementBookFixedAsset(context, payload) {
    let res = null;
    try {
      context.commit('updateLoadingSummary', true);
      res = await api.loadIncrementBookFixedAsset(payload || {});
    } finally {
      context.commit('updateLoadingSummary', false);
    }

    if (res) {
      context.commit('setPaging', res);
      context.commit('setPayload', payload);
    }

    return res;
  },

  /**
   * Lấy những chứng từ liên quan
   * NNKiem 30.01.2023
   */
  async getVoucherReference(context, payload) {
    let res = await api.getVoucherReference(payload || {});
    return res;
  },
};

const mutations = {
  ...crud.mutations,
  /**
   * update lại trạng thái ghi tăng, ghi giảm, điều chỉnh tài sản cố định
   * @param {*} state
   * @param {*} dataUpdate
   */
  updateStausIncrement(state, dataUpdate) {
    if (Array.isArray(state.items)) {
      state.items.forEach(fixedAsset => {
        if (dataUpdate[fixedAsset.fixed_asset_code]) {
          fixedAsset.IsCanBeIncreased = dataUpdate[fixedAsset.fixed_asset_code].IsCanBeIncreased;
          fixedAsset.IsCanBeDereased = dataUpdate[fixedAsset.fixed_asset_code].IsCanBeDereased;
          fixedAsset.IsCanBeAdjusted = dataUpdate[fixedAsset.fixed_asset_code].IsCanBeAdjusted;
        }
      });
    }
  },
  /**
   * Đồng bộ sang dữ liệu cache combo
   * @param {*} state
   * @param {*} items
   */
  deleteItems: (state, items) => {
    crud.mutations.deleteItems(state, items);
    store.dispatch(`${ModuleFixedAssetCache}/deleteItemCombo`, items);
  },
  insertItem: (state, item) => {
    crud.mutations.insertItem(state, item);
    console.log(ModuleFixedAssetCache);
    store.dispatch(`${ModuleFixedAssetCache}/insertItemCombo`, item);
  },
  updateItem: (state, item) => {
    crud.mutations.updateItem(state, item);
    store.dispatch(`${ModuleFixedAssetCache}/updateItemCombo`, item);
  },
  updateItemQuickFllow: (state, item) => {
    crud.mutations.updateItemQuickFllow(state, item);
    store.dispatch(`${ModuleFixedAssetCache}/updateItemQuickFllowCombo`, item);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
